import { render, staticRenderFns } from "./SalesOrderModal.vue?vue&type=template&id=6894bec2&"
import script from "./SalesOrderModal.vue?vue&type=script&lang=js&"
export * from "./SalesOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports